"use client";
import { DialogProvider } from "./context/DialogClientProvider";

const TilesContextWrapper = ({ children }: { children: React.ReactNode }) => {
  return <DialogProvider>{children}</DialogProvider>;
};

export default TilesContextWrapper;
